import React from 'react'
import '../../styles/Hotitemcard.css'

const Hotitemcard = ({name,prize,image,index}) => {
    return (
        <>
        
          <div className="Hotitemcard">
            <img src={image} alt={`${index} product`}></img>
            <p>{name}</p>
            <span>{prize}</span>
          </div>
             {/* <div className="Imglast">
             <img src="https://i01.appmifile.com/webfile/globalimg/in/cms/593181BE-7DB8-15F5-E907-506427B8C9F4.jpg" alt=""></img>
             </div>  */}
        
        </>
    )
}



export default Hotitemcard;
